import React, { Component } from 'react'
import myv from '../video/myv.mp4';


export default class Home extends Component {
  render() {
    return (
      <div>
       
         <video src={myv} autoPlay loop muted />
         <div className='overlay'>
         <div className='container'>
         <div class="row">
         <article>
  <h1>as salam model college old students association</h1>
 
</article>
  </div>
 
  <div class="contain">
    <a className='aa' href="/website">
      <span>Learn More</span>
    </a>
   
    </div>
         </div>
         </div>
        
      </div>
    )
  }
}